import { render, staticRenderFns } from "./AddressEditModal.vue?vue&type=template&id=b3b7c89c&lang=pug&"
import script from "./AddressEditModal.vue?vue&type=script&lang=js&"
export * from "./AddressEditModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressEditModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports